import { render } from "./SwitchPolicyForm.vue?vue&type=template&id=49ebadfc&scoped=true"
import script from "./SwitchPolicyForm.vue?vue&type=script&lang=js"
export * from "./SwitchPolicyForm.vue?vue&type=script&lang=js"

import "./SwitchPolicyForm.vue?vue&type=style&index=0&id=49ebadfc&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ebadfc"]])

export default __exports__